import React from "react";
import Select from "react-select";


const customStyles = {
    control: (base) => ({
        ...base,
        minHeight: "29px",
        borderRadius: "12px",
        borderColor: "#E5E7EB",
        boxShadow: "none",
        borderWidth: '2px',
        fontSize: "14px",
        padding: "0px 2px",
        outline: "none",
        '&:hover': {
            borderColor: "#E5E7EB",
            boxShadow: "none",
        },
    }),
    valueContainer: (base) => ({
        ...base,
        padding: "0 8px",
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: "29px",
    }),
    input: (base) => ({
        ...base,
        margin: 0,
        padding: 0,
    }),
    dropdownIndicator: (base) => ({
        ...base,
        padding: 6,
    }),
    clearIndicator: (base) => ({
        ...base,
        padding: 6,
    }),
    option: (base, { isFocused, isSelected }) => ({
        ...base,
        fontSize: "13px",
        padding: "4px 10px",
        backgroundColor: isSelected ? "#E5E7EB" : isFocused ? "#F3F4F6" : "#fff",
        color: "#111827",
        cursor: "pointer",
    }),
    menu: (base) => ({
        ...base,
        marginTop: 2,
        borderRadius: 6,
        boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        fontSize: "13px",
    }),
    menuList: (base) => ({
        ...base,
        maxHeight: "150px", // Limit height
        overflowY: "auto",  // Enable scroll
        padding: 0,
    }),
};



const CustomReactSelect = ({
    label,
    name,
    value,
    onChange,
    options,
    required,
    isMulti = false,
    isSearchable = true,
    placeholder = "Select...",
    className = "",
    isEditable = true,
    isDisabled = false,
    onInputChange,
    onMenuOpen,
    isLoading = false,
    maxMenuHeight = 180
}) => {
    return (
        <div className={`flex flex-col gap-0.5 w-full ${className}`}>
            <label htmlFor={name} className="block text-sm text-gray-700">
                {label}
            </label>
            <Select
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                options={options}
                isMulti={isMulti}
                isSearchable={isSearchable}
                placeholder={placeholder}
                styles={customStyles}
                classNamePrefix="custom-select"
                required={required}
                onInputChange={onInputChange}
                onMenuOpen={onMenuOpen}
                isLoading={isLoading}
                // menuPlacement="auto"
                // menuPosition="absolute"
                maxMenuHeight={maxMenuHeight}
                isDisabled={!isEditable || isDisabled}
            />

        </div>
    );
};

export default CustomReactSelect;
